import { render, staticRenderFns } from "./FoodGroups.vue?vue&type=template&id=e8a0feac&scoped=true&"
import script from "./FoodGroups.vue?vue&type=script&lang=js&"
export * from "./FoodGroups.vue?vue&type=script&lang=js&"
import style0 from "./FoodGroups.vue?vue&type=style&index=0&id=e8a0feac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a0feac",
  null
  
)

export default component.exports